var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column is-centered",style:(_vm.styles.widthLimitter)},[_c('div',{style:(_vm.styles.renderingAreaProvider)},[_c('iframe',{style:(_vm.styles.iframe),attrs:{"src":_vm.src,"frameborder":"0","allowfullscreen":"true","referrerpolicy":"strict-origin-when-cross-origin"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }